<div class="flex align-items-end justify-content-end input">
  <!-- {{ appSettings.translate[appSettings.selectedLang]['types_filter'] }}: -->
  <p-splitButton
    *ngIf="items.length"
    [label]="
      appSettings.translate[appSettings.selectedLang][appSettings.selectedRacesType.label ? appSettings.selectedRacesType.label : 'void']
    "
    [model]="items"
  ></p-splitButton>
</div>
